module.exports = __webpack_public_path__ + "static/media/sunset_small.681dab6c.jpg";